import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { fields2 } from './form_fields_2'
import { debounceTime, distinctUntilChanged, merge } from 'rxjs';   
import * as _ from  'lodash'; 

@Component({
  selector: 'app-form2',
  templateUrl: './form2.component.html',
  styleUrls: ['./form2.component.scss']
})
export class Form2Component implements OnInit {
  @Output() formChanges = new EventEmitter();
  @Input() audiometryInput:any;
  @Input() presetFilters: any;
  @Input() ageCentile: any;
  @Input() earType: any;
  calcForm: FormGroup;
  calcFormFields: { [key: string]: any } = {
    basic: new FormGroup({
      // standard : new FormControl('guideline')
    })
  };
  // isoTypeList = [{ id: 'guideline', title: 'Guidelines' }, { id: 'iso2000', title: 'ISO7029:2000' }, { id: 'iso2017', title: 'ISO7029:2017' }];
  arhlCalcIn: { [key: string]: any }[] = _.cloneDeep(fields2);
  showAnchor:boolean = false;
  defaultValues: any = {
    "arhlParam": 1
  };
  toggleValue: boolean = false;
  leftEarData: any = [];
  rightEarData: any = [];
  

  constructor(
    private fb:FormBuilder,
  ) {
    this.calcForm = this.fb.group(this.calcFormFields);
   }

  ngOnInit(): void {
     this.calcFormInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes['audiometryInput']) {
      if(changes['audiometryInput'].currentValue) {
        console.log(changes['audiometryInput'])
        this.rightEarData = changes['audiometryInput'].currentValue.rightEar;
        this.leftEarData = changes['audiometryInput'].currentValue.leftEar;
      }
     this.patchNotional();
    }
    if (changes['presetFilters']) {
      this.disableAnchorPoints();
     // this.calcFormInit();
     let cv = changes['presetFilters']['currentValue']
     if(cv){
      this.patchForm();
     }
    }
    if (changes['ageCentile']) {
       this.patchValues();
    }
  }

 patchForm(): void  {
    let changeObj = this.presetFilters?.calcJson;
    // changeObj.basic = {
    //   standard:  this.presetFilters?.reportType
    // };
    if(this.presetFilters?.calcJson?.anchor?.changeAnchorPoints) {
      this.showAnchor = true;
    } else {
      this.showAnchor = false
    }
    this.calcForm.patchValue(changeObj, {
      emitEvent: false,
      onlySelf: true
    })
 }
 isOptionSelected(  groupId:string, questionId:string, value:any) {
   let field = this.calcForm.get([groupId, questionId]);
   //console.log(field?.value);
   if(groupId == 'basic') {
    //  console.log(this.presetFilters);
    //  console.log(field?.value , value, field?.value == value);
   }
    return field?.value == value;
 }
  patchNotional() : void{
    this.calcForm.patchValue({
      exposure: {
        newDbValue: this.audiometryInput.notionalExposure
      }
     },  {emitEvent: false, onlySelf: true});
  }
  patchValues() :void{    
   this.calcForm.patchValue({
    arhlParam: {
      changeAgeTo: parseInt(this.ageCentile?.age),
      changeCentileTo: this.ageCentile?.centile
    }
   },  {emitEvent: false, onlySelf: true});
  }
  isChecked(group:any, question:any, value:any):boolean {
    let g:any = this.calcForm.get(group)
   if(g){
    let field = g['controls'][question.id];
    // console.log(field.value)
    // console.log(value)
    // console.log(field.value == value)
    if(field.value == value) {
      return true;
    }
   }
   
    return false;
  }
  centileValidator():ValidatorFn {
    return (control:AbstractControl ): ValidationErrors | null  => {
      const value = control.value;
      if (!value) {
          return null;
      }
      return (value < 5 || value > 95) ? { invalid: true} : null;
    }
  }

  ageValidator():ValidatorFn {
    return (control:AbstractControl ): ValidationErrors | null  => {
      const value = control.value;
      if (!value) {
          return null;
      }
      return (value < 5 || value > 95) ? { invalid: true} : null;
    }
  }

  calcFormInit() {
    for (const { id, questions } of this.arhlCalcIn) {
      let calcFormGroup: any = {};
      // console.log(questions)
      for (const { title, id, required, relationalId, defaultValue, options } of questions) {
        let defVal:any = '';
        if (defaultValue) defVal = defaultValue;
       
        
        if(this.defaultValues[id]){
          defVal= this.defaultValues[id];
          // console.log(defVal)
          // console.log(id)
        }
        if (id== 'exposure') {
          if(this.presetFilters) {
            defVal = this.presetFilters.calcJson.exposure.exposure ? 
          this.presetFilters.calcJson.exposure.exposure : '1';
          } else {
            defVal = 1;
          }
          // console.log(defVal)
          for (let opt of options) {
            if (opt['id'] == defVal) {
              opt['checked']=true;
            } else {
              opt['checked']=false;
            }
          }          
        }
        if (id == 'arhlParam') {
          if(this.presetFilters) {
            // console.log(this.presetFilters.calcJson.arhlParam.arhlParam)
            defVal = this.presetFilters.calcJson.arhlParam.arhlParam ? 
          this.presetFilters.calcJson.arhlParam.arhlParam : '1';
          }
          
          for (let opt of options) {
            // console.log(opt['id'] + ' and ' +defVal);
            
            if (opt['id'] == defVal) {
              // console.log(true)
              opt['checked']=true;
            } else {
              // console.log(false)
              opt['checked']=false;
            }
          }          
        }
        if (id== 'newDbValue') {
          // console.log('value : ' + this.audiometryInput.notionalExposure)
          if(this.presetFilters) {
            defVal = this.presetFilters.calcJson.exposure.newDbValue ? this.presetFilters.calcJson.exposure.newDbValue : 
            this.audiometryInput.notionalExposure;
          } else {
            defVal = this.audiometryInput.notionalExposure;
          }
          
        }

        if (id == 'changeAnchorPoints') {
          if (this.presetFilters) {
            // console.log('yes present '+ this.presetFilters.calcJson.anchor.changeAnchorPoints)
            if(this.presetFilters.calcJson.anchor.changeAnchorPoints == 'yes') {
              this.showAnchor =true;
              defVal = 'yes';
            } else {
              defVal = ''
              this.showAnchor =false;
            }
          }
        }

        if(id == 'newLowerAnchor') {
          if(this.presetFilters) {
            defVal = this.presetFilters.calcJson.anchor.newLowerAnchor;
          }          
        }

        if(id == 'newUpperAnchor') {
          if(this.presetFilters) {
            defVal = this.presetFilters.calcJson.anchor.newUpperAnchor;
          }          
        }

        if (id== 'changeAgeTo') {
          if(this.presetFilters) {
            if (this.presetFilters.calcJson.arhlParam.changeAgeTo) {
            //   console.log(true)
            // console.log(this.presetFilters.calcJson)
              defVal = parseInt(this.presetFilters.calcJson.arhlParam.changeAgeTo);
            } else {
              if(this.ageCentile) {
                // console.log('ff')
                defVal = parseInt(this.ageCentile.age);
              } else {
                // console.log('fff')
                defVal = 65;
              }
            } 
          } else {
            if(this.ageCentile) {
              // console.log(this.ageCentile)
              defVal =  parseInt(this.ageCentile.age);
            } else {
              defVal = 55;
            }
          }
        }

        if (id== 'changeCentileTo') {
          // if(this.presetFilters) {
          //   console.log(this.presetFilters.calcJson)
          //   defVal = this.presetFilters.calcJson.arhlParam.changeCentileTo ? this.presetFilters.calcJson.arhlParam.changeCentileTo : 
          //   this.audiometryInput.centile || '75';
          // } else {
          //   defVal = this.audiometryInput.centile || '75';
          // }

          if(this.presetFilters) {
            if (this.presetFilters.calcJson.arhlParam.changeCentileTo) {
            // console.log(this.presetFilters.calcJson)
              defVal =  this.presetFilters.calcJson.arhlParam.changeCentileTo;
            } else {
              if(this.ageCentile) {
                // console.log('ff')
                defVal = this.ageCentile.centile;
              } else {
                // console.log('fff')
                defVal = 80;
              }
            } 
          } else {
            // console.log(false)
            if(this.ageCentile) {
              // console.log(this.ageCentile)
              defVal = this.ageCentile.centile;
            } else {
              defVal = '75';
            }
          }
        }

        // if(this.modifierFilter) {
        //   console.log(this.modifierFilter.right.reportType)
        //   console.log(this.calcFormFields['basic'])
        //   // if (this.modifierFilter.right.arhl.arhlPlotting != '' && id== 'arhlPlotting') {
        //   //   defVal = this.modifierFilter.right.arhl.arhlPlotting
        //   // }
        // }

        const formValidator = [];
        const reqValid = required ? formValidator.push(Validators.required) : '';
        if(id == 'changeCentileTo') {
          formValidator.push(this.centileValidator());
        }
        if(id == 'changeAgeTo') {
          formValidator.push(this.ageValidator());
        }
        if(id == 'newDbValue') {
          formValidator.push(Validators.min(85));
          formValidator.push(Validators.max(125));
        }
        calcFormGroup[id] = [defVal, formValidator]
      }
       this.calcFormFields[id] = this.fb.group(calcFormGroup)
      //  console.log(this.calcFormFields)
    }
    // console.log(this.calcFormFields);
    this.calcForm = this.fb.group(this.calcFormFields)
    
    if(this.presetFilters) {
      // console.log(this.calcForm)
      // this.calcForm.patchValue({
      //   basic: {
      //     standard: this.presetFilters.reportType
      //   }
      //  },  {emitEvent: false, onlySelf: true});
    } 
    
    this.calcForm.get(['anchor','changeAnchorPoints'])?.valueChanges.subscribe((val => {
      // console.log('valu changed')
        if(val){
          // console.log(val)
          this.showAnchor =true;
          // console.log(fields2)
          // console.log(this.arhlCalcIn)
          this.disableAnchorPoints();
        }else{
          // console.log('no val')
          this.showAnchor = false;
          this.calcForm.patchValue({
            anchor: {
              newLowerAnchor: '',
              newUpperAnchor: ''
            }
           },  {emitEvent: false, onlySelf: true});
        }
    }))
   

    merge(
      this.calcForm.get(['arhlParam','changeAgeTo'])!.valueChanges,
      this.calcForm.get(['arhlParam','changeCentileTo'])!.valueChanges
    ).subscribe((val)=> {
     if(val != ''){
      this.calcForm.patchValue({
        arhlParam: {
          arhlParam: 2
        }
      },  {emitEvent: false, onlySelf: true})
     }
    })
    this.calcForm.get(['exposure', 'newDbValue'])?.valueChanges.subscribe((val => {
      if(val != '') {
        this.calcForm.patchValue({
          exposure: {
            exposure: 2
          }
        },  {emitEvent: false, onlySelf: true})
      }
    }))
    this.calcForm.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(val => {
        val["anchor"]["changeAnchorPoints"] =  val["anchor"]["changeAnchorPoints"] ? 'yes' : '';
        if(this.calcForm.valid){
          this.formChanges.emit(val);
        }
    })
  }

  disableAnchorPoints() {
    if(this.arhlCalcIn[1]['id'] === 'anchor') {
      // console.log(this.arhlCalcIn[1]['questions'])
      for (let ques of this.arhlCalcIn[1]['questions']) {
        if (ques.id === 'newUpperAnchor') {
          // console.log(ques.options)
          if(ques.options) {
            ques.options.forEach((option: { id: any; title: any; }) => {
              // console.log(`ID: ${option.id}, Title: ${option.title}`);
              
            });
            // console.log(this.rightEarData);
            // console.log(this.leftEarData);
            if (this.earType == 'right') {
              for (const key in this.rightEarData) {
                if (key === "6000hz" || key === "8000hz") {
                    if (`${this.rightEarData[key]}` == '') {
                     const tempKey=`${key}`.replace("hz", "");
                      ques.options = ques.options.filter((option: { id: string; }) => option.id !== tempKey);
                    }
                }
              }
            }
            if (this.earType == 'left') {
              for (const key in this.leftEarData) {
                if (key === "6000hz" || key === "8000hz") {
                    if (`${this.leftEarData[key]}` == '') {
                     const tempKey=`${key}`.replace("hz", "");
                      ques.options = ques.options.filter((option: { id: string; }) => option.id !== tempKey);
                    }
                }
              }
            }
            // ques.options = ques.options.filter(option => option.id !== "6000");
          }
          // console.log(fields2[1].questions)
        }
        if (ques.id === 'newLowerAnchor') {
          // console.log('new lower anchor')
          // console.log(ques.options)
          if(ques.options) {
            ques.options.forEach((option: { id: any; title: any; }) => {
              // console.log(`ID: ${option.id}, Title: ${option.title}`);
              
            });
            // console.log(this.rightEarData);
            // console.log(this.leftEarData);
            if (this.earType == 'right') {
              for (const key in this.rightEarData) {
                if (key === "500hz" || key === "1000hz" || key === "2000hz") {
                    if (`${this.rightEarData[key]}` == '') {
                      // console.log(`${key}: ${this.rightEarData[key]}`);
                     const tempKey=`${key}`.replace("hz", "");
                      // console.log(tempKey)
                      ques.options = ques.options.filter((option: { id: string; }) => option.id !== tempKey);
                    }
                }
              }
            }
            
            if (this.earType == 'left') {
              for (const key in this.leftEarData) {
                if (key === "500hz" || key === "1000hz" || key === "2000hz") {
                    
                    if (`${this.leftEarData[key]}` == '') {
                      // console.log(`${key}: ${this.leftEarData[key]}`);
                     const tempKey=`${key}`.replace("hz", "");
                      // console.log(tempKey)
                      ques.options = ques.options.filter((option: { id: string; }) => option.id !== tempKey);
                    }
                }
              }
            }
            
            // ques.options = ques.options.filter(option => option.id !== "6000");
          }
        }
      }
    }
  }

  buttonSwitchClick(question: any, option: any, id:any) {
    if(option.title == 'Original' && id == 'exposure') {
      this.calcForm.patchValue({
        exposure: {
          newDbValue: this.audiometryInput.notionalExposure
        }
      }, {
        onlySelf: true,
        emitEvent: false
      })
    }
    if(option.title == 'Customised' && id == 'exposure') {
      this.calcForm.patchValue({
        exposure: {
          newDbValue: this.presetFilters?.calcJson?.exposure?.newDbValue ? this.presetFilters?.calcJson?.exposure?.newDbValue : this.audiometryInput.notionalExposure
        }
      }, {
        onlySelf: true,
        emitEvent: false
      })
    }

    if(option.title == 'Best Fit' && id == 'arhlParam') {
     if(this.calcForm.get(['arhlParam', 'arhlParam'])?.value != '1'){
       this.calcForm.patchValue({
        arhlParam: {
          changeAgeTo: this.ageCentile?.age,
          changeCentileTo: this.ageCentile?.centile
        }
      }, {
        onlySelf: true,
        emitEvent: false
      })
     }
    } else if(option.title == 'Customised' && id == 'arhlParam') {
      this.calcForm.patchValue({
        arhlParam: {
          changeAgeTo:  this.presetFilters?.calcJson?.arhlParam?.changeAgeTo,
          changeCentileTo: this.presetFilters?.calcJson?.arhlParam?.changeCentileTo,
        }
      }, {
        onlySelf: true,
        emitEvent: false
      })
    }

    this.calcForm.patchValue({
      [id]: {
        [question.id]: option.id
      }
    }, {
      onlySelf: true,
      emitEvent: false
    })
  }

  isVisible(id:any):boolean {
    if(id == 'newUpperAnchor' || id == 'newLowerAnchor'){
      return this.showAnchor;
    }
    return true;
  }

  hasError(section:string, id:string):boolean {
    let errors = this.calcForm.get(section)?.get(id)?.errors;
    if(!errors) {
      return false;
    }
    return Object.keys(errors).length > 0 ?  true : false;
  }

}
